import React from 'react';
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock, setAlert} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal, handleChange} from 'Skelet/src/modules/functions.js'
import {time_togo} from 'Skelet/src/modules/time_ago.js'
import {getRequiredParameters} from 'Skelet/src/modules/required_parameters.js'
import ModalPassword from './ModalPassword.js'
import ModalMollie from './ModalMollie.js'
import refresh_icon from '../images/refresh-icon.svg';

// @TODO_WHN reset timeout after new submit. Even though people are unlikely to re-send the exact same field within 2 seconds.

class Settings extends React.Component {

  constructor(props) {
    super(props);
    let account = this.props.apiData["login"].data;
    let account_parameters = (account.parameters) ? JSON.parse(account.parameters) : {};
    this.state = {
      email:account.email, firstname:account.firstname, lastname:account.lastname, parameters:account_parameters,
      current_email:account.email, current_firstname:account.firstname, current_lastname:account.lastname, current_parameters:account_parameters,
      password:'', password_current:'',
      loading:0
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setPasswords = this.setPasswords.bind(this);
    this.fillField = this.fillField.bind(this);
  }

  // @TODO_WHN reset loading animation on error (e.g. invalid password)
  componentWillReceiveProps(nextProps) {
    if(nextProps.apiData["account_update"] !== undefined && Object.keys(nextProps.apiData["account_update"]["data"]).length > 0) {
      let newState = Object.assign({}, this.state);
      let updated_data = nextProps.apiData["account_update"]["data"];
      let loading = 0;
      let updated_state = {};
      for (var prop in updated_data) {
        loading = 2;
        if(prop !== "password" && prop !== "parameters") {
          updated_state["current_"+prop] = updated_data[prop];
        } else if(prop === "password") {
          updated_state["password"] = '';
          updated_state["password_current"] = '';
        } else if(prop === "parameters") {
          let parsed = JSON.parse(updated_data[prop]);
          Object.assign(newState.current_parameters, parsed);
        }
      }
      newState.loading = loading;
      Object.assign(newState, updated_state);
      this.props.clearStateBlock("account_update");
      this.setState(newState);
    }
  }

  render() {
    let plan_description = <span dangerouslySetInnerHTML={{__html:this.props.i18n_texts["core_settings_trial"][this.props.app_language]}}></span>;
    const {account_plan, account_created} = this.props;
    if(account_plan === "trial") {
      let account_created_at = new Date(account_created);
      let trial_time_togo = time_togo(account_created_at.getTime() + 20160*1000*60);
      plan_description = <span>Free 14-day <b>Trial</b> plan, unlimited polls & votes.<br/><i style={{opacity:".5"}}>You have {trial_time_togo} left in your Trial.</i></span>;
      if(this.props.app_language === "NL") {
        plan_description = <span>Gratis 14-dagen <b>Trial</b>, ongelimiteerde polls & stemmen.<br/><i style={{opacity:".5"}}>Je hebt nog {trial_time_togo} te gaan in jouw Trial.</i></span>;
      }
    }
    if(account_plan === "premium") {plan_description = <span><b>Pro</b> plan, unlimited polls & votes.</span>;}

    return (
      <div className="container thin-container content">
        <ModalPassword
          shouldShow={this.state.modal_open}
          close={() => closeModal(this)}
          setPasswords={this.setPasswords}
          account_update_is_fetching={this.props.account_update_is_fetching}
          i18n_texts={this.props.i18n_texts}
          app_language={this.props.app_language}
        />
        <ModalMollie
          shouldShow={this.state.modal_mollie_open}
          close={() => closeModal(this, "modal_mollie_open")}
          i18n_texts={this.props.i18n_texts}
          app_language={this.props.app_language}
        />
        <strong>{this.props.i18n_texts["core_menu_settings"][this.props.app_language]}</strong>
        <div className="card settings">
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="section-title">Account</div>
              <div style={{margin:"10px auto"}}><span>{this.state.email}</span></div>
              <div><input type="text" value={this.state.firstname} onChange={(e) => handleChange(this, "firstname", e)} placeholder="First name" /></div>
              <div><input type="text" value={this.state.lastname} onChange={(e) => handleChange(this, "lastname", e)} placeholder="Last name" /></div>
              <div><Link to="/" className="btn" onClick={(e) => openModal(this, e)}>{this.props.i18n_texts["core_settings_changepassword"][this.props.app_language]}</Link></div>
            </div>
            <div className="row">
              <div className="form-actions">{this.loader()}<input type="submit" value={this.props.i18n_texts["core_settings_save"][this.props.app_language]} disabled={this.props.account_update_is_fetching} /></div>
            </div>
          </form>
        </div>
        {/*Activity / History (history nog niet, enkel plan of iets, evt voor admin)*/}
        <div className="card settings">
          <div className="row">
            <div className="section-title">{this.props.i18n_texts["core_settings_billing"][this.props.app_language]}</div>
            <div style={{textAlign:"right"}}><Link to="/" onClick={(e) => this.refreshPlan(e)}>{this.props.i18n_texts["core_settings_refresh"][this.props.app_language]} <img src={refresh_icon} alt={this.props.i18n_texts["core_polls_refresh"][this.props.app_language]}/></Link></div>
            <div style={{margin:"10px auto"}}>
              <table style={{width:"100%", textAlign:"left", fontSize:"90%"}}>
                <tbody>
                <tr><td>Plan</td><td>{plan_description}</td></tr>
                {(account_plan === "lite" || account_plan === "trial") && <tr><td>{this.props.i18n_texts["core_settings_go"][this.props.app_language]} <a href={(this.props.app_language === "NL") ? "/prijzen" : "/en/pricing"} target="_blank" rel="noopener noreferrer" onClick={() => {document.getElementById("main").scrollIntoView(true);}}>Pro</a></td><td><Link to="/" className="btn" onClick={(e) => openModal(this, e, null, "modal_mollie_open")} style={{color:"#279bea"}}>{this.props.i18n_texts["core_settings_starting"][this.props.app_language]}</Link></td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  loader() {
    if(this.state.loading === 0) {
      return null;
    } else if(this.state.loading === 1) {
      return <span className="loading-wrapper"><div className="loading"><span></span><span></span><span></span></div></span>;
    } else if(this.state.loading === 2) {
      setTimeout(function(){
        this.setState({loading: 0});
      }.bind(this), 2000);
      return <span className="loading-wrapper"><span>&#10004;</span></span>;
    }
  }

  fillField(state_name) {
    if(this.state.parameters !== null && this.state.parameters[state_name] !== undefined) {
      return this.state.parameters[state_name];
    }
    return "";
  }

  handleChangeParameters(e, state_name) {
    let newState = Object.assign({}, this.state.parameters, {[state_name]:e.target.value});
    this.setState({parameters: newState});
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.props.account_update_is_fetching === false || this.props.account_update_is_fetching === null) {
      let payload = this.createPayload();
      if(Object.keys(payload).length > 0) {
        payload.session_token = this.props.session_token;
        this.props.fetchDataIfReady(config.api_token, "account_update", "PATCH", config.api_url+"/account-update", JSON.stringify(payload), null, true, false, true, "login");
      }
    }
  }

  createPayload() {
    let payload = {}, payload_loading = {};

    let firstname = this.state.firstname;
    if(firstname !== this.state.current_firstname) {
      payload.firstname = firstname;
      payload_loading = 1;
    }

    let lastname = this.state.lastname;
    if(lastname !== this.state.current_lastname) {
      payload.lastname = lastname;
      payload_loading = 1;
    }

    let password = this.state.password;
    let password_current = this.state.password_current;
    if(password !== '' && password_current !== '') {
      payload.password = password;
      payload.current_password = password_current; // API needs "current_password"
      payload_loading = 1;
    }

    if(Object.keys(this.state.parameters).length > 0) {
      let validated = this.validateParameters(payload, payload_loading);

      if(validated.valid_required_parameters && validated.valid_characters) {
        this.setState({loading: validated.payload_loading});
        return validated.payload;
      } else if(!validated.valid_required_parameters) {
        this.props.setAlert("Not all required fields are filled in.");
        return false;
      } else if(!validated.valid_characters) {
        this.props.setAlert("Used invalid characters: \\ , ' , \" .");
        return false;
      }
    } else {
      this.setState({loading: payload_loading});

      return payload;
    }
  }

  validateParameters(payload, payload_loading) {
    let update_parameters = {};
    let required_parameters = getRequiredParameters();
    let optional_parameters = ["email_opt","tel_opt"];
    let valid_required_parameters = true, valid_characters = true;

    for(let i=0;i<optional_parameters.length;i++) {
      let item = this.state.parameters[optional_parameters[i]];
      if((this.state.current_parameters === null && item !== undefined) || item !== this.state.current_parameters[optional_parameters[i]]) {
        update_parameters[optional_parameters[i]] = item;
      }
      // @TODO_WHN log when these characters are used?
      // @TODO_V1 change single quotes to escaped characters or something, for example the word "collega's" would now give an error
      if(item !== undefined && (item.indexOf("\\") >= 0 || item.indexOf("'") >= 0 || item.indexOf("\"") >= 0)) {
        valid_characters = false;
      }
    }

    for(let i=0;i<required_parameters.length;i++) {
      let item = this.state.parameters[required_parameters[i]];
      // @TODO_WHN: validation per type (postal code, website url, etc)
      if(item !== this.state.current_parameters[required_parameters[i]]) {
        update_parameters[required_parameters[i]] = item;
      }
      if(item === undefined || item.trim() === "") {
        valid_required_parameters = false;
      }
      if(item !== undefined && (item.indexOf("\\") >= 0 || item.indexOf("'") >= 0 || item.indexOf("\"") >= 0)) {
        valid_characters = false;
      }
    }

    if(Object.keys(update_parameters).length > 0) {
      payload.parameters = {};
      payload_loading = 1;
      for (var prop in update_parameters) {
        payload.parameters[prop] = update_parameters[prop];
      }
    }

    return {"payload":payload, "payload_loading":payload_loading, "valid_required_parameters":valid_required_parameters, "valid_characters":valid_characters};
  }

  setPasswords(password, password_current) {
    this.setState({"password":password, "password_current":password_current});
  }

  refreshPlan(e) {
    e.preventDefault();
    this.props.clearStateBlock("plan");
    this.props.setAlert(this.props.i18n_texts["core_settings_refreshalert"][this.props.app_language], "info");
  }

}


function mapStateToProps(state) {
  let session_token = null, account_update_is_fetching = null, account_plan = null, account_created = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["account_update"] !== undefined && state.apiData["account_update"].isFetching !== undefined) {
    account_update_is_fetching = state.apiData["account_update"].isFetching;
  }
  if(state.apiData["plan"] !== undefined && state.apiData["plan"]["data"]["name"] !== undefined) {
    account_plan = state.apiData["plan"]["data"]["name"];
    account_created = state.apiData["plan"]["data"]["account_created"];
    if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["email"] !== undefined && state.apiData["login"]["data"]["email"] === "hi@peter.plus") {
      account_plan = "premium";
    }
  }
  return {
    account_plan: account_plan,
    account_created: account_created,
    account_update_is_fetching: account_update_is_fetching,
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/containers/Settings.js